// extracted by mini-css-extract-plugin
export default {"addNewSampleContainer":"AddNewFormSample_addNewSampleContainer__YdOE3","jsonInputContainer":"AddNewFormSample_jsonInputContainer__EHi3Y"};